import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=72fda24c&scoped=true"
import script from "./InfoRow.vue?vue&type=script&lang=js"
export * from "./InfoRow.vue?vue&type=script&lang=js"
import style0 from "./InfoRow.vue?vue&type=style&index=0&id=72fda24c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fda24c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72fda24c')) {
      api.createRecord('72fda24c', component.options)
    } else {
      api.reload('72fda24c', component.options)
    }
    module.hot.accept("./InfoRow.vue?vue&type=template&id=72fda24c&scoped=true", function () {
      api.rerender('72fda24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoRow.vue"
export default component.exports